import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Icon, Button, Header, Input, Popup } from 'semantic-ui-react'

import styles from '../styles/global.module.scss'

const actionButton =
	`ui basic button ${styles.Bordered}` + ' ' + `${styles.shadowOnHover}`
const rowActionButton = `${styles.IconButton}` + ' ' + `${styles.nonBordered}`

const AnimatedButton = (props) => {
	const {
		size,
		float,
		iconname,
		disabled,
		placeholder = undefined,
		animated = true,
		rotate,
		title,
		content,
		holdPopup = false,
		holdPopupContent,
		bordered = false,
		basic = false,
		style = {},
		popupSize,
	} = props

	// Extract className and style from props so we can merge them
	const { className: propClassName, style: propStyle, onClick: propOnClick, ...rest } = props

	const [clicked, setClicked] = useState(false)

	const onClick = (e) => {
		e.preventDefault()
		setClicked(!clicked)
		propOnClick && propOnClick(e)
	}
	return (
		<>
			{placeholder && !holdPopup && (
				<Popup
					trigger={
						<button
							className={`${rowActionButton} ${propClassName || ''}`}
							disabled={disabled}
							onClick={onClick}
							style={{ ...style, ...propStyle, cursor: 'pointer' }}
							{...rest}
						>
							{iconname && (
								<Icon
									className={styles.IconLabel}
									name={iconname}
									rotated={rotate}
								></Icon>
							)}
							{content}
						</button>
					}
					content={placeholder}
					on='hover'
				/>
			)}
			{!placeholder && !holdPopup && (
				<Button
					className={`${actionButton} ${propClassName || ''}`}
					disabled={disabled}
					onClick={onClick}
					style={{ ...style, ...propStyle }}
					color={props.color || 'blue'}
					size={size}
					{...rest}
				>
					{iconname && content ? (
						<>
							<Icon name={iconname} />
							{content}
						</>
					) : iconname ? (
						<Icon name={iconname} />
					) : (
						content
					)}
				</Button>
			)}
			{!placeholder && holdPopup && (
				<Popup
						trigger={
							<button
								size={size}
								className={`${rowActionButton} ${propClassName || ''}`}
								style={{
									...style,
									...propStyle,
									cursor: 'pointer',
								}}
								floated={float}
								disabled={disabled}
								onClick={onClick}
								{...rest}
							>
								{iconname && <Icon name={iconname} rotated={rotate}></Icon>}
							</button>
						}
					content={holdPopupContent}
					on='click'
					position='bottom center'
					onClose={props.onClose}
					size={size}
					style={popupSize}
				/>
			)}
		</>
	)
}

AnimatedButton.propTypes = {
	size: PropTypes.string,
	float: PropTypes.string,
	iconname: PropTypes.string,
	disabled: PropTypes.bool,
	onClick: PropTypes.func,
	animated: PropTypes.bool,
	holdPopup: PropTypes.bool,
	holdPopupContent: PropTypes.object,
	onClose: PropTypes.func,
	bordered: PropTypes.bool,
	basic: PropTypes.bool,
}

export default AnimatedButton
